import { createSharedComposable, useActiveElement } from '@vueuse/core'
import { computed, onMounted, ref } from 'vue'

function _useShortcuts() {
  const macOS = computed(() => import.meta.client && typeof navigator !== 'undefined' && /Macintosh;/.test(navigator.userAgent))
  const metaSymbol = ref(' ')
  const activeElement = useActiveElement()
  const usingInput = computed<string | true | false>(() => {
    const el = activeElement.value as (HTMLElement & { name?: string }) | null
    const tagName = el?.tagName
    const contentEditable = el?.contentEditable
    const using = tagName === 'INPUT' || tagName === 'TEXTAREA' || contentEditable === 'true' || contentEditable === 'plaintext-only'
    if (using) {
      return el?.name || true
    }
    return false
  })

  onMounted(() => {
    metaSymbol.value = macOS.value ? '⌘' : 'Ctrl'
  })

  return { macOS, metaSymbol, activeElement, usingInput }
}

export const useShortcuts = createSharedComposable(_useShortcuts)
